(function(){

  'use strict';

    //*****************//
    // Data that this directive needs
    // -----------------
    // 
    //*****************//

    // 
    // }

  function pxMassDistribution(PrinterListService) {
    return {
      restrict: 'EA',
      scope: {
        massDistributionData: '=massDistributionData',
        callback: '&callback'
      },
      templateUrl: 'app/directives/massDistribution/mass-distribution.template.html',
      link: function(scope) {

        scope.filtersList = scope.massDistributionData.paginationObjects;
        scope.popupObject = {};
        scope.appliedFilters = {};
        scope.allItemsCount = null;
        scope.allItemsPercent = null;
        scope.approveMassDristribution = false;

        (function(){

          clearPreviousFilters();
          prepareFiltersArrays();
          getPaginatedItems();
        })();

        function clearPreviousFilters() {
          scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.networks = null
          scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.matchVendorModel = null
        }

        function prepareFiltersArrays () {
          angular.forEach(scope.massDistributionData.paginationObjects, function(filterObject) {
            scope.appliedFilters[filterObject.name] = [];
          })
        }

        function getPaginatedItems() {
          if (scope.massDistributionData.massDistributionObject.service === 'PrinterListService') {
            scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.pageSize = 1;
            scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.types= 'VIRTUAL,NETWORK';
            PrinterListService.getPrinterListPaged(scope.massDistributionData.massDistributionObject.paginationObject).then(function (pageContent) {
              scope.pageContent = pageContent;
              if (!scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.networks && !scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.matchVendorModel) {
                scope.allItemsCount = angular.copy(pageContent.page.totalElements);
              }
              checkValidityOfMassDistribution();
            }).catch(function(error){});
          }
        }

        scope.openPopup = function($event, context) {
          scope.clearPopups();
          $event.stopPropagation();
          scope.popupObject[context] = findPopupObject(context);   
        }

        function findPopupObject(context) {
          var popupObject;
          for (var i = 0; i < scope.massDistributionData.paginationObjects.length; i++) {
            if (context === scope.massDistributionData.paginationObjects[i].name) {
              popupObject = scope.massDistributionData.paginationObjects[i].popup;
            }
          }
          return popupObject;
        }

        scope.clearPopups = function () {
          scope.popupObject = {};
        }

        scope.setFilter = function(items, context) {
          angular.forEach(items, function(item) {
            scope.appliedFilters[context].add(item);
          })
          updatePagingCriteria(scope.appliedFilters[context], context);
        }
        
        scope.removeFilter = function (item, context) {
          scope.appliedFilters[context].remove(item);
          updatePagingCriteria(scope.appliedFilters[context], context);
        }

        scope.setCheckboxValue = function(value) {
          scope.approveMassDristribution = value;
          checkValidityOfMassDistribution();
        }
        
        function checkValidityOfMassDistribution() {
          if (scope.approveMassDristribution && scope.pageContent.page.totalElements > 0) {
            scope.callback({item: scope.appliedFilters, boolean: true});
          } else {
            scope.callback({item: scope.appliedFilters, boolean: false});
          }
        }
        
        function updatePagingCriteria(filter, context) {
          scope.massDistributionData.checkboxData.value = false;
          switch (context) {
            case 'Networks': 
              scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.networks = stringifyFilterIds(filter);
              break;
            case 'Vendors': 
              scope.massDistributionData.massDistributionObject.paginationObject.pagingCriteria.matchVendorModel = stringifyFilterName(filter);
            break;
          }
          getPaginatedItems();
        }

        function stringifyFilterIds(filter) {
          var filterString = '';
          angular.forEach(filter, function(filterInstance) {
            filterString += filterInstance.info._links.self.href +',';
          })
          return filterString
        }

        function stringifyFilterName(filter) {
          var filterString = '';
          angular.forEach(filter, function(filterInstance) {
            filterString += filterInstance.info.name +',';
          })

          if (filterString.charAt(filterString.length - 1) === ',') {
            filterString = filterString.substring(0, filterString.length - 1);
          }

          return filterString
        }

      }
    };
  }

  pxMassDistribution.$inject = ['PrinterListService'];

  angular
    .module('printix-admin')
    .directive('pxMassDistribution', pxMassDistribution);

})();